(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(scope) {
      var els = (scope || document).querySelectorAll('.about [data-reveal]:not(.is-visible)');
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') { reveal(); }
    else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__spiceCartInit) return;
    window.__spiceCartInit = true;

    var SECTION = 'cart-drawer';

    function drawer() { return document.querySelector('[data-cart-drawer]'); }

    function open() {
      var d = drawer();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var panel = d.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    }

    function close() {
      var d = drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function setLoading(on) {
      var d = drawer();
      if (d) d.classList.toggle('is-loading', !!on);
    }

    function updateCount(n) {
      var count = parseInt(n, 10) || 0;
      var pill = document.querySelector('[data-cart-count-pill]');
      if (pill) pill.textContent = count;

      document.querySelectorAll('.site-header__cart').forEach(function (link) {
        var badge = link.querySelector('.site-header__count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__count';
            link.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function applyResponse(data) {
      if (data && data.sections && data.sections[SECTION]) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data.sections[SECTION];
        var fresh = tmp.querySelector('[data-cart-drawer-content]');
        var live = document.querySelector('[data-cart-drawer-content]');
        var freshFooter = tmp.querySelector('[data-cart-footer]');
        var liveFooterParent = document.querySelector('.cart-drawer__panel');
        var liveFooter = document.querySelector('[data-cart-footer]');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          live.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count'));
          updateCount(fresh.getAttribute('data-cart-count'));
        }
        if (liveFooter) liveFooter.remove();
        if (freshFooter && liveFooterParent) liveFooterParent.appendChild(freshFooter);
      }
    }

    function postCart(endpoint, body) {
      setLoading(true);
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({ sections: [SECTION], sections_url: window.location.pathname }, body))
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { applyResponse(data); return data; })
        .finally(function () { setLoading(false); });
    }

    function changeLine(line, quantity) {
      return postCart('/cart/change.js', { line: line, quantity: quantity });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.classList.add('is-loading');

      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);

      setLoading(true);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { return; }
          applyResponse(data);
          open();
        })
        .finally(function () {
          setLoading(false);
          if (btn) btn.classList.remove('is-loading');
        });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

      var cartLink = e.target.closest('.site-header__cart');
      if (cartLink) { e.preventDefault(); open(); return; }

      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      var item = e.target.closest('[data-cart-item]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-cart-qty-input]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;

      if (minus) { e.preventDefault(); changeLine(line, Math.max(0, current - 1)); }
      else if (plus) { e.preventDefault(); changeLine(line, current + 1); }
      else if (remove) { e.preventDefault(); changeLine(line, 0); }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var item = input.closest('[data-cart-item]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(line, q);
    });

    document.addEventListener('submit', function (e) {
      var promo = e.target.closest('[data-cart-promo]');
      if (!promo) return;
      e.preventDefault();
      var input = promo.querySelector('[data-cart-promo-input]');
      var code = (input && input.value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-promo-apply]');
      if (!btn) return;
      var wrap = btn.closest('.cart-page__promo');
      var input = wrap && wrap.querySelector('[data-cart-promo-input]');
      var code = (input && input.value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(scope) {
      var els = (scope || document).querySelectorAll('.contact [data-reveal]:not(.is-visible)');
      if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') { reveal(); }
    else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__siteHeaderInit) return;
    window.__siteHeaderInit = true;

    function closeAll() {
      document.querySelectorAll('.site-header.is-open').forEach(function (header) {
        header.classList.remove('is-open');
        var toggle = header.querySelector('.site-header__toggle');
        var panel = header.querySelector('.site-header__mobile');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.site-header__toggle');
      if (toggle) {
        e.preventDefault();
        var header = toggle.closest('.site-header');
        var panel = header.querySelector('.site-header__mobile');
        var willOpen = !header.classList.contains('is-open');
        closeAll();
        if (willOpen) {
          header.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          if (panel) panel.hidden = false;
        }
        return;
      }

      if (e.target.closest('.site-header__mobile a')) {
        closeAll();
        return;
      }

      if (!e.target.closest('.site-header')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__pdp) return;
      root.__pdp = true;

      var script = root.querySelector('[data-pdp-variants]');
      if (!script) return;
      var variants;
      try { variants = JSON.parse(script.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-pdp-id]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var saveEl = root.querySelector('[data-pdp-save]');
      var addBtn = root.querySelector('[data-pdp-add]');
      var addText = root.querySelector('[data-pdp-add-text]');
      var mainImg = root.querySelector('[data-pdp-main]');
      var optionGroups = root.querySelectorAll('[data-option]');
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');

      function currentValues() {
        var vals = [];
        optionGroups.forEach(function (g) {
          var checked = g.querySelector('input:checked');
          vals.push(checked ? checked.value : null);
        });
        return vals;
      }

      function matchVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options || v.options.length !== vals.length) continue;
          var ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (v.options[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function activateThumb(thumb) {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        var full = thumb.getAttribute('data-full');
        if (mainImg && full) {
          // Drop the responsive attributes so the explicit high-res image wins.
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = full;
        }
        if (thumb.scrollIntoView) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      function update() {
        optionGroups.forEach(function (g) {
          var checked = g.querySelector('input:checked');
          var label = g.querySelector('[data-option-selected]');
          if (checked && label) label.textContent = checked.value;
        });

        var v = matchVariant(currentValues());
        if (!v) return;

        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          if (v.compare_at) { compareEl.textContent = v.compare_at; compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (saveEl) {
          if (v.save > 0) { saveEl.textContent = 'Save ' + v.save + '%'; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (addBtn && addText) {
          if (v.available) { addBtn.disabled = false; addText.textContent = 'Add to cart'; }
          else { addBtn.disabled = true; addText.textContent = 'Sold out'; }
        }
        if (v.image_id) {
          thumbs.forEach(function (t) {
            if (String(t.getAttribute('data-image-id')) === String(v.image_id)) activateThumb(t);
          });
        }
      }

      root.querySelectorAll('[data-option] input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', update);
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activateThumb(t); });
      });

      var qty = root.querySelector('.pdp__qty-input');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (qty && minus) minus.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        qty.value = Math.max(1, n - 1);
      });
      if (qty && plus) plus.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        qty.value = n + 1;
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-pdp-root]').forEach(init);
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spice-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.documentElement;
    root.classList.add('spice-js');

    function reveal(scope) {
      var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-visible)');
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState !== 'loading') {
      reveal();
    } else {
      document.addEventListener('DOMContentLoaded', function () { reveal(); });
    }

    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spice-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btns = document.querySelectorAll('.spice-news__copy[data-code]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code');
        navigator.clipboard.writeText(code).then(function () {
          btn.classList.add('is-copied');
          var copyIcon = btn.querySelector('.spice-news__copy-icon');
          var checkIcon = btn.querySelector('.spice-news__check-icon');
          if (copyIcon) copyIcon.style.display = 'none';
          if (checkIcon) checkIcon.style.display = 'block';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (copyIcon) copyIcon.style.display = 'block';
            if (checkIcon) checkIcon.style.display = 'none';
          }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
